import { API_NAMES, initApi } from "@usas/ui-web/utils/HttpApiHelper";
import { BASIC_INITIAL_STATE } from "@usas/ui-web/utils/HttpHelper";

const getNTContactsData = (personId, state, setState) => {
  const api = initApi(API_NAMES.PERSON, state, setState);

  const personIdForUrl = personId ? encodeURIComponent(personId) : 0;
  const url = `/Person/${personIdForUrl}/personNationalTeamContact`;

  return api.executeObject ? api.executeObject(url, 'GET') : null;
};

const putNTContactsData = (personId, personNTContactsObj, state, setState) => {
  if (personNTContactsObj) {
    const api = initApi(API_NAMES.PERSON, state, setState);

    const personIdForUrl = personId ? encodeURIComponent(personId) : 0;
    const url = `/Person/${personIdForUrl}/personNationalTeamContact`;

    return api.executeObject ? api.executeObject(url, 'PUT', personNTContactsObj) : null;
  }
};

const INITIAL_NATIONAL_TEAM_CONTACTS_STATE = {
  ...BASIC_INITIAL_STATE
};

const NTContactsData = {
  INITIAL_NATIONAL_TEAM_CONTACTS_STATE,
  getNTContactsData,
  putNTContactsData
};

export default NTContactsData;